import type {IVStoreState} from '../useIVStore.ts';

export const getSetupFormData = (state: IVStoreState) => state.setupData;
